import styled from "styled-components";

export const Style = styled.div`
  h3 {
    font-size: 18px;
    font-weight: 500;
    color: #001529;
  }

  .g2-tooltip {
    z-index: 102 !important;
  }

  .w-p {
    padding: 0 var(--size-lg);
  }
  
  .g2-tooltip-list {
    padding-top: 10px !important;
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 26px;
    margin-bottom: 26px;
    
    .info-row {
      display: flex;
      justify-content: space-between;
    
      p {
        margin-bottom: 0px;
        color: #344054;
        font-size: var(--font-size-lg);
        font-weight: 500;
      }

      .value {
        &.tag {
          background: #F9FAFB;
          padding: 2px 10px;
          margin-top: -2px;
          border-radius: 16px;

          p {
            color: #BABABA;
            font-size: 14px;
          }

          &.tag-0 {
            background: #F9FAFB;
            p {color: #BABABA; }
          }
          &.tag-1 {
            background: #EEFFE8;
            p {color: #7BC762; }
          }
          &.tag-2 {
            background: #FFFAEB;
            p {color: #F8AB38; }
          }
          &.tag-3 {
            background: #FEF6EE;
            p {color: #E87C40; }
          }
          &.tag-4 {
            background: #FFF4ED;
            p {color: #CF5439; }
          }
          &.tag-5 {
            background: #FEF3F2;
            p {color: #B9362D; }
          }
        }
      }
    }
  }
`;
